// HUD : compteurs Famille / Cherche / Trouvé, dans le viseur (Famille = Cherche + Trouvé, toujours), score de la partie, batterie
// du viseur (se vide à chaque photo, clignote quand il ne reste que quelques vues), joueur et niveau
import { $ } from './dom.js';
import { countFoundTypes, countRemainingTypes } from '../core/world.js';
import { LOW_BATTERY_SHOTS } from '../config/constants.js';
import { FAMILY_MEMBERS } from '../data/family.js';

/**
 * Niveau de charge de la batterie pour un nombre de vues restantes, et signal « presque vide ».
 * Monochrome : la batterie est un repère de l'appareil, pas un indicateur coloré. Fonction pure.
 */
export function batteryState(filmLeft, filmShots) {
  const ratio = filmShots > 0 ? Math.max(0, Math.min(1, filmLeft / filmShots)) : 0;
  return { ratio, low: filmLeft <= LOW_BATTERY_SHOTS };
}

/** @param {{ t: (key: string, params?: object) => string }} i18n */
export function createStats({ t }) {
  const family = $('stat-family');
  const remaining = $('stat-remaining');
  const found = $('stat-found');
  const battery = $('vfBattery');
  const batteryFill = $('vfBatteryFill');
  const batteryInnerWidth = Number(batteryFill.getAttribute('data-full-width')) || 18;
  const level = $('sb-level');
  const score = $('stat-score');

  return {
    /** Score de la partie (#37), déjà mis en forme : il change chaque seconde, à part du reste du HUD. */
    updateScore(text) {
      if (score.innerText !== text) score.innerText = text;
    },
    update({ ghosts, filmLeft, filmShots, currentLevel, familySize = FAMILY_MEMBERS.length, longLife = false }) {
      // Toujours les 15 types de la famille, quel que soit le niveau : les doublons des niveaux
      // supérieurs (voir core/level.js) sont des fantômes en plus à l'écran, pas une cible plus
      // grande à atteindre.
      family.innerText = familySize;
      remaining.innerText = countRemainingTypes(ghosts, familySize);
      found.innerText = countFoundTypes(ghosts);
      const b = batteryState(filmLeft, filmShots);
      batteryFill.setAttribute('width', String(Math.round(batteryInnerWidth * b.ratio * 100) / 100));
      battery.classList.toggle('is-low', b.low);
      battery.classList.toggle('is-long-life', longLife); // batterie longue durée : une autre teinte
      battery.setAttribute('aria-label', t('viewfinder.battery', { left: filmLeft, total: filmShots }));
      level.innerText = t('app.level', { level: currentLevel });
    },
  };
}
